// src/components/ThemeSwitcher.js
import React, { useEffect, useState } from 'react';

const THEMES = [
  { id: 'dim',      icon: '🌙', label: 'Dim',      desc: 'Soft dark — easy on the eyes' },
  { id: 'midnight', icon: '🌌', label: 'Midnight', desc: 'Deep navy, high contrast' },
  { id: 'light',    icon: '☀️', label: 'Light',    desc: 'Bright background' }
];

function getInitialTheme() {
  try {
    return localStorage.getItem('rm_theme') || 'dim';
  } catch (_) {
    return 'dim';
  }
}

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(getInitialTheme);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('rm_theme', theme); } catch (_) {}
  }, [theme]);

  const current = THEMES.find(t => t.id === theme) || THEMES[0];

  return (
    <div className="theme-switcher">
      <button
        className="theme-switcher-trigger"
        onClick={() => setOpen(o => !o)}
        title="Change color theme"
        aria-label="Change color theme"
      >
        {current.icon}
      </button>
      {open && (
        <>
          <div className="theme-switcher-backdrop" onClick={() => setOpen(false)} />
          <div className="theme-switcher-menu">
            {THEMES.map(t => (
              <button
                key={t.id}
                className={`theme-option${theme === t.id ? ' active' : ''}`}
                onClick={() => { setTheme(t.id); setOpen(false); }}
              >
                <span>{t.icon} {t.label}</span>
                <small>{t.desc}</small>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
